/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientArrivalConfirmationAliases {
  ARRIVAL_CANCEL = 'arrival-cancel',
  ARRIVAL_CONFIRM = 'arrival-confirm',
  CONTEXTUAL_BAR_ARRIVAL = 'contextual-bar-arrival',
  FIELD_ATENDIMENTO = 'field-atendimento',
  FIELD_DESTINO = 'field-destino',
  FORM_FIELDS = 'form-fields',
  FRAGMENT_REFERENCE_ARRIVAL = 'fragment-reference-arrival',
  GLOBAL_ACTIONS_ARRIVAL = 'global-actions-arrival',
  LAYOUT_MAIN = 'layout-main',
  PANEL_LOADER = 'panel-loader',
  TEXT_ATENDIMENTO = 'text-atendimento',
  TEXT_DESTINO = 'text-destino',
}
export { PatientArrivalConfirmationAliases };
